var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute left-0 top-0 h-full w-full",class:{
    'bg-dark-700': _vm.bg
  }},[_c('div',{staticClass:"h-full w-full flex flex-col items-center justify-center"},[_c('v-ui-spinner',_vm._b({},'v-ui-spinner',_vm.$attrs,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }